import React from "react";
import { View, ViewStyle } from "react-native";
import { IconProps } from "@xsolla/xui-primitives-core";

export const Icon: React.FC<IconProps> = ({
  children,
  color,
  size,
  testID,
  "data-testid": dataTestId,
}) => {
  const style: ViewStyle = {
    width: typeof size === "number" ? size : undefined,
    height: typeof size === "number" ? size : undefined,
    alignItems: "center",
    justifyContent: "center",
  };

  // On native, we try to pass the color down to children (like Text primitives)
  // to mimic the CSS inheritance behavior of the web version.
  const childrenWithProps = React.Children.map(children, (child) => {
    if (React.isValidElement(child)) {
      return React.cloneElement(child, {
        color: child.props.color || color,
        // Also pass size if child seems to be an icon that needs it
        size: child.props.size || size,
      });
    }
    return child;
  });

  return (
    <View style={style} testID={dataTestId || testID}>
      {childrenWithProps}
    </View>
  );
};
